// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"a4fd1bf3c67acf2ed5d4","339":"94443288c11c611876fc"}[chunkId] + ".js";
};